import styled from "styled-components"

import { SvgIcon } from "@components/common"

export const Icon = styled(SvgIcon)`
  transform: rotate(90deg);
  margin-right: 5px;
`
